import React from "react";
import CartItem from "./CartItem";
import BillDetailsCard from "./BillDetailsCard";
import { useSelector } from "react-redux";

const CartListContainer = () => {
  const products = useSelector((state) => state.cartItems);

  return (
    <div className="cartListContainer">
      <div className="space-y-6">
        {products.length === 0 ? (
          <p className=" font-bold text-lg text-red-500">
            No Items added to the cart
          </p>
        ) : (
          products.map((item) => <CartItem key={item?.id} item={item} />)
        )}
      </div>
      <BillDetailsCard />
    </div>
  );
};

export default CartListContainer;
